import _, {isNil} from "lodash";

export const SidebarLinksPageMixin = {
    data() {
        return {

        }
    },
    mounted() {

    },
    methods: {
        canSeeLink(link) {
            if (_.isNil(link)) {
                return false
            }

            // Check that the link passes its show check and we have the permissions to view the link.
            return this.linkCheckShow(link) && this.linkHasPermission(link)
        },
        parseCompanyLinks(links) {
            _.each(links, (link, index) => {
                // Replace `$company` with the company id.
                links[index].link = _.replace(
                        link.link, '$company', this.company.getCompanyId())
            })

            return links
        },
        linkCheckShow(link) {
            if (_.has(link, 'show')) {
                // A show test was defined, run it, returning the result.
                return link.show()
            }

            // There is no show test and we should return true.
            return true
        },
        linkHasPermission(link) {
            // If no permission is set, then the link is always available.
            if (_.isNil(link.permission)) {
                return true
            }

            // If the permission requirement is an array of permissions, check each.
            if (_.isArray(link.permission)) {
                // Start with the assumption that the user has permission.
                let hasPermission = true
                _.each(link.permission, (permission) => {
                    // If the user does not have permission, set the flag to false.
                    if (! this.permissions.can(permission)) {
                        hasPermission = false
                    }
                })

                // Return if the user has the permission.
                return hasPermission
            }

            // If the permission requirement is a single permission, check it.
            return this.permissions.can(link.permission)
        },
    },
    computed: {

    },
}

SidebarLinksPageMixin.NOVA_ACCESS_PERMISSION = 'access_nova'